import { useLang } from '@/i18n';
import {
  googleCalendarUrl,
  outlookCalendarUrl,
  downloadIcs,
} from '@/lib/calendar';
import styles from './CalendarExport.module.css';

type EventLike = {
  name: string;
  eventDate: string;
  eventTime: string;
  location?: string | null;
  subheading?: string | null;
};

export function CalendarExport({ event }: { event: EventLike }) {
  const { t } = useLang();
  return (
    <div className={styles.wrap}>
      <p className={styles.title}>{t('calendar_add_title')}</p>
      <div className={styles.btns}>
        <a
          className={styles.btn}
          href={googleCalendarUrl(event)}
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="ph ph-google-logo" aria-hidden="true" />
          <span>{t('calendar_google')}</span>
        </a>
        <button
          type="button"
          className={styles.btn}
          onClick={() => downloadIcs(event)}
        >
          <i className="ph ph-apple-logo" aria-hidden="true" />
          <span>{t('calendar_apple')}</span>
        </button>
        <a
          className={styles.btn}
          href={outlookCalendarUrl(event)}
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="ph ph-microsoft-outlook-logo" aria-hidden="true" />
          <span>{t('calendar_outlook')}</span>
        </a>
      </div>
    </div>
  );
}
